module.exports = __webpack_public_path__ + "img/ico-delete.0f559c3f.svg";